import axios from 'axios'

const ax = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_HOST,
  withCredentials: true
})

const api = {}

api.queryIdInfo = () => ax.get('/id-info')
api.queryIdInfoRequest = (requestId) =>
  ax.get(`/paci-req?requestId=${requestId}`)
api.updateIdInfo = (info) => ax.post('/id-info', info)
api.upsertCustomer = (info) => ax.post('/upsert', info)

api.validateToken = (token) => ax.post('/validate-token', { token })
api.postKycRecord = (recordData) => ax.post('/kyc-records', recordData)


// ==== Partners ====
api.getSimInfo = (partner) => ax.get('/partner-info', { params: { partner }})

api.upsertPartnerPACI = (civilId, email, partner) => ax.post('/paci-partner', {civilId, email, partner})
api.upsertPartnerScan = async (info) => ax.post('/upsert-partner', {info})
api.postKycPartnerRecord = async (paciRecordData) => ax.post('/kyc-partner-record', {paciRecordData})


export default api
